export class Constants {

    public static _ALL: number = -1;
    public static _NONE: number = -2;
    public static _YES: number = 1;
    public static _NO: number = 0;
public static _SEVERITY_INFO = "INFO";
    public static _SEVERITY_WARNING = "WARNING";
    public static _SEVERITY_ERROR = "ERROR";
    public static _ACCOUNT_GROUP_SOLD_TO: string = "Z001";
    public static _ACCOUNT_GROUP_PAYER: string = "Z003";
    public static _UPLOAD_METHOD: string = "/FileUploads/UploadFile";
    public static _UPLOAD_COMPLETION_INFO_METHOD: string = "/FileUploads/UploadCompletionInfo";
    public static _UPLOAD_MASS_UPDATE_FILE_METHOD: string = "/FileUploads/UploadMassUpdateFile";
    public static _HEADER_EMPLOYEE_ID: string = "EmployeeID";
    public static _HEADER_REQUEST_ID: string = "RequestID";
    public static _DEFAULT_TRADE_NAME_CODE = "99999";
    public static _DEFAULT_KEY_ACCOUNT_CODE = "A9999";
    public static _DEFAULT_TRADE_GROUP_CODE = "A9999";
    public static _DEFAULT_ORDER_METHOD_ID = 1;
    public static _DEFAULT_CONTACT_FUNCTION_ID = 3;
    public static _DEFAULT_CUSTOMER_TYPE_ID = 1;
    public static _DEFAULT_GOODS_RECEIVING_HOURS_START = "08:00:00";
    public static _DEFAULT_GOODS_RECEIVING_HOURS_END = "17:00:00";
    public static _PAPERWORK_ONLY_MOVE_EXTERNAL_URL = "https://portal.cokeonena.com/irj/portal/";
    public static _EMAIL_REQUEST_WITH_SUPPRESS_CONFIRMATION = "You have indicated that this customer should be suppressed, which would prevent the customer from placing future orders. Once suppressed, the customer can no longer be unsuppressed.  If a business relationship is re-established , a new outlet will need to be requested. Are you sure you want to continue?";
    public static _EMAIL_REQUEST_WITH_OWNERSHIP_CHANGE = "You have indicated that this customer is being requested due to a change in ownership which will suppress the old outlet once equipment is transferred. The old outlet will not be able to place future orders and can no longer be unsuppressed. Are you sure you want to continue?";
    public static _SUBMIT_REQUEST_WITH_DIFFERENT_SALES_OFFICE = "You are about to submit a Full Service Pricing request for a Sales Office other than the on you are assigned to. Are you sure you want to continue?";
    public static _REQUEST_ALREADY_EMAILED = "This Request has already been emailed, and cannot be emailed again.";
    public static _ONE_OR_MORE_REQUESTS_ALREADY_EMAILED = "One or more of the selected Requests has already been emailed, and cannot be emailed again.";
    public static _DEFAULT_REJECT_COMMENTS_FOR_SUPPRESSION_REQUESTS = "The outlet requested to be suppressed has equipment attached.  Please request a removal notification.  Once the equipment is picked up, please re-submit your suppression request.  If the equipment does not physically exist at the outlet, then please request a paper work only removal through Aries to LOST Equipment.  Once completed, then re-submit the suppression. Thank you."
    public static _BLOCK_TEXT_SUBMIT_PARTNER_FUNCTION = "Your request is being processed.  Please do not click the back button or refresh the browser.";
    public static _MIGRATED_REQUEST_TYPE_MSG = "Invoice and Statement Copy requests are transitioning away from Aries " +
    "and this request type will be removed in 2027. " +
    "To obtain invoice or statement copies, please direct your customer to myCoke." +
    "Questions or support needs should be directed to: " +
    "mycokesupport@reyesccb.com." +
    "Thank you for helping us transition to our future - state customer servicing tools.";
    public static _HOSTED_BY_CONTACT_DETAILS = "contactDetails"
    public static _HOSTED_BY_BILLING_ADDRESS = "billingAddress"
    
    public static _DISTRIBUTION_CHANNEL_DSD: string = "Z1";
    public static _DISTRIBUTION_CHANNEL_FSV: string = "Z3";
    
    
    public static _TENANT_NAME = "reyesholdings.com";
    
}

export default Constants;
